import axios from '@/utils/api'

const state = {
}

const getters = {
}

const actions = {
  async finalisar ({ commit }, dados) {
    const data = await axios({
      method: 'post',
      data: dados,
      url: `financeiro/custasAgrarias`
    })
    return data
  },
  async getCustasAgrarias ({ commit }) {
    const data = await axios({
      method: 'get',
      url: 'financeiro/custasAgrarias'
    })
    return data
  },
  async getNumeroDiarias ({commit}, idProcesso) {
    const data = await axios({
      method: 'get',
      url: `financeiro/custasAgrarias/numeroDiarias/${idProcesso}`

    })
    return data
  },
  async getNumeroModulos ({commit}, numeroProtocolo) {
    const data = await axios({
      method: 'get',
      url: `financeiro/custasAgrarias/numeroModulos/${numeroProtocolo}`

    })
    return data
  }
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/analise/custas.js